import storage from '@/utils/storage'

export function cache (key, value) {
  storage.saveItem(key, value, window.localStorage)
}

export function getCache (key) {
  return storage.getItem(key)
}

export function cacheState (state) {
  Object.keys(state).forEach(key => {
    cache(key, state[key])
  })
}

export function cachedState (state, skipProps) {
  Object.keys(state).forEach(key => {
    if (skipProps && skipProps.indexOf(key) > -1) { return }
    const cached = getCache(key)
    if (cached != null) {
      state[key] = cached
    }
  })
  return state
}



// WEBPACK FOOTER //
// ./src/store/utils.js